import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { LayoutGridType } from "../ReactPageLayout/LayoutGridType";
import { LayoutRow } from "../ReactPageLayout/LayoutRow";
import { PluginHelper } from "../ReactPageLayout/helpers/PluginHelper";
export function ContainerCell(props) {
    var _a, _b;
    const { node, componentContext } = props;
    // lookup special component for rendering containers
    const components = useContext(componentContext);
    const pluginId = PluginHelper.getPluginId(node);
    const Component = (_a = components[pluginId]) !== null && _a !== void 0 ? _a : ContainerComponentFallback;
    // sub layout for child nodes
    const children = (_jsx(Fragment, { children: (_b = node.rows) === null || _b === void 0 ? void 0 : _b.map((row) => (_jsx(LayoutRow, { node: row, gridType: LayoutGridType.Container }, row.id))) }));
    // map props for the component
    const componentProps = PluginHelper.getPluginProps(props.node);
    return _jsx(Component, Object.assign({}, componentProps, { children: children }));
}
function ContainerComponentFallback(props) {
    return _jsx(Fragment, { children: props.children });
}
//# sourceMappingURL=ContainerCell.js.map